module.exports = __webpack_public_path__ + "static/img/reward-coin-receice.8be07ff.png";